import InternalKeyboard from './InternalKeyboard';

export default InternalKeyboard;
